// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"styles__infoButton___1jQyN"};